import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Globals } from "src/app/globals";
import { ConflictosService } from "../../servicios/conflictos.service";
import Swal from "sweetalert2";
import { ConsultarPreguntasService } from "../../../administrador-preguntas/consultar-preguntas.service";

@Component({
  selector: "app-cierre-conflicto",
  templateUrl: "./cierre-conflicto.component.html",
  styleUrls: ["./cierre-conflicto.component.css"]
})
export class CierreConflictoComponent implements OnInit {
  @Input() idConflicto;
  @Input() IdActualizacion;
  @Input() infoConflicto;
  @Input() infoRespuesta;

  

  preguntaCerrar;
  nombreCampo;
  botonCerrar;
  botonCancelar;

  control: FormControl = new FormControl("", [Validators.required]);
  grupoFormulario: FormGroup = new FormGroup({});

  constructor(
    private ConsultarPreguntas: ConsultarPreguntasService,
    public globals: Globals,
    private conflictosService: ConflictosService
  ) {}

  ngOnInit() {
    this.grupoFormulario.addControl("justificacion", this.control);
    if (this.globals.lenguaje == "es") {
      this.nombreCampo = "Justificación";
      this.preguntaCerrar = "Por favor justifica tu respuesta:";
      this.botonCerrar = "Guardar";
      this.botonCancelar = "Cancelar";
    } else {
      this.nombreCampo = "Justification";
      this.preguntaCerrar = "Please justify your answer:";
      this.botonCerrar = "Save";
      this.botonCancelar = "Cancel";
    }
  }

  cerrarConflicto() {
    //////conole.log(this.idConflicto);

    if (this.grupoFormulario.status == "VALID") {
      let valores = this.grupoFormulario.value;
      let etiquetaCargando = { es: "Cargando", en: "Loading" };
      Swal.fire(etiquetaCargando[this.globals.lenguaje]);
      Swal.showLoading();



      
    if (this.IdActualizacion == "0") {
    
      //////conole.log("Verdadero");

    
      this.ConsultarPreguntas.InsertarValorConflicto(
        this.idConflicto,
        "Conflicto ya no existe"
      ).subscribe(ArrayResultados => {    
        
        this.conflictosService
         .cerrarConflicto(
           this.idConflicto,
           this.globals.IdFuncionarioTablaFuncionarios,
           valores["justificacion"],
           this.infoConflicto,
           this.infoRespuesta
         ).subscribe(datos => {
          //////conole.log(datos);
          Swal.close();
          this.globals.ConflictosVarGlobal = "";
        });

        
        

      });

    } else {
      
      this.ConsultarPreguntas.ActualizarValorConflictoCerrado(
        this.IdActualizacion,
        "Conflicto ya no existe"
      ).subscribe(ArrayResultados => {

        this.conflictosService
         .cerrarConflicto(
           this.idConflicto,
           this.globals.IdFuncionarioTablaFuncionarios,
           valores["justificacion"],
           this.infoConflicto,
           this.infoRespuesta,
         ).subscribe(datos => {
          //////conole.log(datos);
          Swal.close();
          this.globals.ConflictosVarGlobal = "";
        });
      
                   
      });

    }

         


       
    }
  }

  cancelar() {
    //////conole.log(this.idConflicto);
    this.globals.ConflictosVarGlobal = "";
  }
}
